import type { ProductUpdatesEnvironment } from './interface';
import environmentUrls from '../../config/environments.json';

/**
 * Dynamic environment (production API + staging baseUrl).
 * URLs sourced from config/environments.json (shared with SSR server).
 */

const url = new URL(location.href);
export const environment: ProductUpdatesEnvironment = {
  production: false,
  angularProdMode: true,
  apiUrl: environmentUrls.staging.apiUrl + '/',
  baseUrl: `${url.origin}/${url.pathname
    .split('/')
    .filter(v => !!v)
    .slice(0, 2)
    .join('/')}`,
  i18n: {
    defaultLocale: 'en',
    availableLocales: ['en', 'de', 'nl', 'fr'],
  },
  sentry: {
    dsn: 'https://ce62ef20bd51ad23442b27125500cc1d@o18167.ingest.us.sentry.io/4510696321712128',
    environmentName: 'development',
  },
};
